import React from 'react';

const VideosTab = ({ courseDetails, currentVideoIndex, handleVideoClick }) => {
    return (
        <div id="video-list">
            {courseDetails?.videos?.length > 0 ? (
                courseDetails.videos.map((video, index) => (
                    <div
                        key={video.uid}
                        className={`video-item ${index === currentVideoIndex ? 'active' : 'inactive'}`}
                        onClick={() => handleVideoClick(index)}
                        style={{
                            cursor: 'pointer',
                            padding: '10px',
                            borderBottom: '1px solid #ddd',
                            display: 'flex',
                            justifyContent: 'space-between',
                            backgroundColor: index === currentVideoIndex ? '#F0F4F8' : 'transparent',
                            fontSize: '16px',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    id={`learnedCheckbox_${video.uid}`}
                                    checked={video.is_learned}
                                    disabled
                                />
                                <label htmlFor={`learnedCheckbox_${video.uid}`}></label>
                            </div>

                            <h3
                                className="video-title"
                                style={{
                                    paddingLeft: '5px',
                                    color: index === currentVideoIndex ? '#44526E' : (video.is_learned ? '#8B8B8B' : '#000'),
                                    margin: '5px 0',
                                }}
                            >
                                {video.chapter || 'No Title Available'}
                            </h3>
                        </div>
                        {video.duration ? (
                            <p className="video-duration" style={{ margin: '5px 0', color: '#666' }}>
                                {video.duration} นาที
                            </p>
                        ) : (
                            <p className="video-duration" style={{ margin: '5px 0', color: '#666', textAlign: 'right' }}>
                                Duration not available
                            </p>
                        )}
                    </div>
                ))
            ) : (
                <p>ไม่มีวิดีโอในตอนนี้</p>
            )}
        </div>
    );
};

export default VideosTab;
